import { AllAccessesScreen } from "@components/Accesses/AllAccessesScreen";

export default AllAccessesScreen;
